import {createApp, VueElement} from 'vue';
import Form from './Form.vue';


createApp(Form).mount('#form');